// extracted by mini-css-extract-plugin
export var optionGrid = "_97-7";
export var optionList = "_97-6";
export var questionsBlock = "_97-9";
export var spacer = "_97-5";
export var stepCenteredContent = "_97-3";
export var stepInner = "_97-0";
export var stepInnerFullWidth = "_97-1";
export var stepInnerLockScroll = "_97-2";
export var stepTransitionFrame = "_97-4";
export var welcomeBlock = "_97-8";